import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const SeasonalPlanting = () => {
  return (
    <Box>
      <Typography variant="h3" gutterBottom className="vintage-script-header">
        Seasonal Planting
      </Typography>
      
      <Paper sx={{
        p: 3,
        background: 'transparent',
        border: '2px solid var(--color-border-vintage)',
        borderRadius: 0,
        boxShadow: 'none',
        position: 'relative'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, var(--color-accent-gold) 0%, transparent 50%, var(--color-accent-gold) 100%)'
        }}></div>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6,
          mt: 2
        }}>
          Learn the optimal times for planting different crops throughout the year. 
          Our seasonal guides help you maximize your garden's potential and make the most 
          of each growing season.
        </Typography>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6,
          mt: 2
        }}>
          Discover how to use Agritur's seasonal planning features to schedule your 
          plantings, track growth cycles, and ensure continuous harvests throughout 
          the year.
        </Typography>
      </Paper>
    </Box>
  );
};

export default SeasonalPlanting;
